import { MutationTree } from 'vuex';
import { DocumentEditState, state as initalState } from '../stores/document-edit.store';
import { IRecipient } from '@/types/Recipient';
import { IDocument } from '@/types/Document';
import { ISender } from '@/types/Sender';
import { EnumDocumentType } from '@/enums/DocumentType';

export const mutationAddingRecipient = 'addingRecipient';
export const mutationLoadingRecipients = 'loadingRecipients';
export const mutationSetRecipients = 'setRecipients';
export const mutationSetIsSigning = 'setIsSigning';
export const mutationLoadDocumentData = 'loadingDocument';
export const mutationSetDocumentData = 'setDocument';
export const mutationSetIsSigningOrder = 'setIsSigningOrder';
export const mutationSetIsSelfsign = 'setIsSelfsign';
export const mutationSetSender = 'setSender';
export const mutationRemoveVideo = 'removeVideo';
export const mutationSetVideo = 'setVideo';
export const mutationSetNewType = 'setNewType';
export const mutationInitalizeDocumentEdit = 'initializeDocumentEdit';
export const mutationSetDocumentId = 'setDocumentId';
export const mutationSetActiveTab = 'setActiveTab';
export const mutationSetError = 'setError';

export const mutations: MutationTree<DocumentEditState> = {
  [mutationSetNewType](state, newType: EnumDocumentType) {
    state.documentType = newType;
  },
  [mutationInitalizeDocumentEdit](state) {
    Object.keys(state).forEach(key => {
      state[key] = initalState[key];
    });
  },
  [mutationAddingRecipient](state, payload: boolean) {
    state.isAddingRecipient = payload;
  },
  [mutationLoadingRecipients](state, payload: boolean) {
    state.isLoadingRecipients = payload;
  },
  [mutationSetRecipients](state, payload: IRecipient[]) {
    state.recipients = payload;
  },
  [mutationSetIsSigning](state, payload: boolean) {
    state.isSigning = payload;
  },
  [mutationLoadDocumentData](state, payload: boolean) {
    state.isLoadingDocument = payload;
  },
  [mutationSetDocumentData](state, payload: IDocument) {
    state.isSigning = payload.isSigning;
    state.isSigningOrder = payload.isSigningOrder;
    state.isSelfsign = payload.isSelfsign;
    state.documentType = payload.type;
    state.isVideo = payload.isVideo;
    state.videoId = payload.videoId;
    state.id = payload.id || '';
  },
  [mutationSetIsSigningOrder](state, payload: boolean) {
    state.isSigningOrder = payload;
  },
  [mutationSetIsSelfsign](state, payload: boolean) {
    state.isSelfsign = payload;
  },
  [mutationSetSender](state, payload: ISender) {
    state.sender = payload;
  },
  [mutationRemoveVideo](state) {
    state.videoId = '';
    state.isVideo = false;
  },
  [mutationSetVideo](state, payload: string) {
    state.videoId = payload;
    state.isVideo = true;
  },
  [mutationSetDocumentId](state, payload: string) {
    state.id = payload;
  },
  [mutationSetActiveTab](state, payload: string) {
    state.activeTab = payload;
  },
  [mutationSetError](state: DocumentEditState, error: boolean) {
    state.error = error;
  },
};
